import type { ClassroomSettingsDto, ScheduleItemDto } from '../../api/types.js';
import { TodayCard } from './TodayCard.js';
import { TodoBox } from './TodoBox.js';
import { TurnInBox } from './TurnInBox.js';
import styles from './HomeOlder.module.css';

export interface HomeOlderProps {
  classroomId: string;
  settings: ClassroomSettingsDto | null;
  schedule: readonly ScheduleItemDto[];
  /** Today's message (per-day record / carry-forward). */
  message: string;
}

/**
 * The 4–8 ("g48") Home layout. Keeps the existing TodayCard (greeting +
 * teacher's message + today's scheduled announcements) up top, then a row of
 * two glass boxes — Turn-In (subjects + today's assignments) and To-Do. The
 * big home mascot is hidden for this variant (see LiveSurface) so the boxes
 * get the room.
 */
export function HomeOlder({ classroomId, settings, schedule, message }: HomeOlderProps) {
  return (
    <section className={styles.board} data-testid="home-page" data-variant="g48">
      <div className={styles.headline}>
        <TodayCard settings={settings} schedule={schedule} message={message} />
      </div>
      <div className={styles.boxes} data-testid="home-older-boxes">
        <TurnInBox classroomId={classroomId} />
        <TodoBox classroomId={classroomId} />
      </div>
    </section>
  );
}
